// override default clipboard, only paste in plain text
const Clipboard = Quill.import('modules/clipboard');
const Delta = Quill.import('delta');
class PlainClipboard extends Clipboard {
  onPaste(e) {
    e.preventDefault();
    const range = this.quill.getSelection();
    const text = e.clipboardData.getData('text/plain');
    const delta = new Delta().retain(range.index).delete(range.length).insert(text);
    const index = text.length + range.index;
    const length = 0;
    this.quill.updateContents(delta, 'user');
    this.quill.setSelection(index, length, 'user');
    this.quill.scrollIntoView();
  }
}
Quill.register('modules/clipboard', PlainClipboard, true);

angular.module('tgaAdmin').constant('NG_QUILL_CONFIG', {
  /*
     * @NOTE: this config/output is not localizable.
    */
  modules: {
    toolbar: {
      container:
        [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          // ['blockquote', 'code-block'],
          // [{ 'header': 1 }, { 'header': 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          // [{ 'indent': '-1' }, { 'indent': '+1' }],  // outdent/indent
          // [{ 'direction': 'rtl' }],  // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          // [{ 'font': [] }],
          [{ align: [] }],

          ['clean'], // remove formatting button

          ['link'], // link
          // ['link', 'image', 'video'], // link and image, video
        ],
    },

  },
  theme: 'snow',
  placeholder: '',
  readOnly: false,
  bounds: 'self',
});

angular.module('tgaAdmin').config([
  'ngQuillConfigProvider',
  'NG_QUILL_CONFIG',
  function (ngQuillConfigProvider, NG_QUILL_CONFIG) {
    ngQuillConfigProvider.set(NG_QUILL_CONFIG);
  },
]);
